﻿const leftColumn = 40; //The x coordinate for the left column of artifactBlocks
const rightColumn = 450;
const midddleColumn = 245;
const baseYOffset = 40; //Padding
const artifactBlockSideLength = 125 + 2 + 2; // 125 width + 2 border each side
const spacing = 160; //constant
const connectionStartOffset = 5;
const connectionEndOffset = 15;

const mapArtifactsObject = {
  "Customer Order": {
    name: "Customer Order",
    code: 1002,
    x: leftColumn,
    y: baseYOffset,
    alignment: "left",
    sourceWorkflowOperationIds: [101010],
    targetWorkflowOperationIds: [],
  },
  "Customer Order Ack": {
    name: "Customer Order Ack",
    code: 1024,
    x: leftColumn,
    y: baseYOffset + 1 * spacing,
    alignment: "left",
    sourceWorkflowOperationIds: [],
    targetWorkflowOperationIds: [101040],
  },
  "Customer Order Change": {
    name: "Customer Order Change",
    code: 1001,
    x: leftColumn,
    y: baseYOffset + 2 * spacing,
    alignment: "left",
    sourceWorkflowOperationIds: [101020],
    targetWorkflowOperationIds: [],
  },
  "Customer Order Change Ack": {
    name: "Customer Order Change Ack",
    code: 1006,
    x: leftColumn,
    y: baseYOffset + 3 * spacing,
    alignment: "left",
    sourceWorkflowOperationIds: [],
    targetWorkflowOperationIds: [101050],
  },
  "Customer Order Status": {
    name: "Customer Order Status",
    code: 1021,
    x: leftColumn,
    y: baseYOffset + 4 * spacing,
    alignment: "left",
    sourceWorkflowOperationIds: [],
    targetWorkflowOperationIds: [101030],
  },
  "Customer Prepayment": {
    name: "Customer Prepayment",
    code: 1033,
    x: midddleColumn,
    y: baseYOffset + 5 * spacing,
    alignment: "right",
    sourceWorkflowOperationIds: [],
    targetWorkflowOperationIds: [103040]
  },
  "Customer Routing Request": {
    name: "Customer Routing Request",
    code: 1004,
    x: leftColumn,
    y: baseYOffset + 7 * spacing,
    alignment: "left",
    sourceWorkflowOperationIds: [],
    targetWorkflowOperationIds: [102030],
  },
  "Customer Routing Confirmation": {
    name: "Customer Routing Confirmation",
    code: 1003,
    x: leftColumn,
    y: baseYOffset + 8 * spacing,
    alignment: "left",
    sourceWorkflowOperationIds: [102040],
    targetWorkflowOperationIds: [],
  },
  "Customer Shipment Notice": {
    name: "Customer Shipment Notice",
    code: 1008,
    x: leftColumn,
    y: baseYOffset + 10 * spacing,
    alignment: "left",
    sourceWorkflowOperationIds: [],
    targetWorkflowOperationIds: [102060],
  },
  "Customer Invoice": {
    name: "Customer Invoice",
    code: 1015,
    x: leftColumn,
    y: baseYOffset + 12 * spacing,
    alignment: "left",
    sourceWorkflowOperationIds: [],
    targetWorkflowOperationIds: [103010],
  },
  "Customer Credit Note": {
    name: "Customer Credit Note",
    code: 1012,
    x: leftColumn,
    y: baseYOffset + 14 * spacing,
    alignment: "left",
    sourceWorkflowOperationIds: [],
    targetWorkflowOperationIds: [103020],
  },
  "Customer Inventory Availability": {
    name: "Customer Inventory Availability",
    code: 1020,
    x: leftColumn,
    y: baseYOffset + 15 * spacing,
    alignment: "left",
    sourceWorkflowOperationIds: [],
    targetWorkflowOperationIds: [102020],
  },
  "Sales Order": {
    name: "Sales Order",
    code: 1005,
    x: rightColumn,
    y: baseYOffset + 2 * spacing,
    alignment: "right",
    sourceWorkflowOperationIds: [101050, 101040, 101030, 102010, 103040],
    targetWorkflowOperationIds: [101010, 101020],
  },
  "Pick Order": {
    name: "Pick Order",
    code: 1023,
    x: rightColumn,
    y: baseYOffset + 6 * spacing,
    alignment: "right",
    sourceWorkflowOperationIds: [],
    targetWorkflowOperationIds: [102010],
  },
  "Packed Order": {
    name: "Packed Order",
    code: 1028,
    x: rightColumn,
    y: baseYOffset + 8 * spacing,
    alignment: "right",
    sourceWorkflowOperationIds: [102051],
    targetWorkflowOperationIds: [102040, 102030],
  },
  Shipment: {
    name: "Shipment",
    code: 1007,
    x: rightColumn,
    y: baseYOffset + 10 * spacing,
    alignment: "right",
    sourceWorkflowOperationIds: [102060],
    targetWorkflowOperationIds: [102051],
  },
  Invoice: {
    name: "Invoice",
    code: 1013,
    x: rightColumn,
    y: baseYOffset + 12 * spacing,
    alignment: "right",
    sourceWorkflowOperationIds: [103010],
    targetWorkflowOperationIds: [],
  },
  "Credit Note": {
    name: "Credit Note",
    code: 1014,
    x: rightColumn,
    y: baseYOffset + 14 * spacing,
    alignment: "right",
    sourceWorkflowOperationIds: [103020],
    targetWorkflowOperationIds: [],
  },
  "Inventory Availability": {
    name: "Inventory Availability",
    code: 1025,
    x: rightColumn,
    y: baseYOffset + 15 * spacing,
    alignment: "right",
    sourceWorkflowOperationIds: [102020],
    targetWorkflowOperationIds: [],
  },
};

const mapArtifacts = Object.values(mapArtifactsObject);

const adjustAttachmentPoint = (x, y, position, adjustment) => {
  adjustment = adjustment || 5;
  switch (position) {
    case "top":
      return { x, y: y - adjustment };
    case "left":
      return { x: x - adjustment, y };
    case "right":
      return { x: x + adjustment, y };
    case "bottom":
      return { x, y: y + adjustment };
    default:
      return { x, y };
  }
};

const calculateEdgeFractionPoints = (x, y, fraction, adjustment) => {
  const fractionLength = artifactBlockSideLength / fraction;
  const points = {};

  for (let i = 1; i < fraction; i++) {
    points[`top${i}Fraction`] = adjustAttachmentPoint(
      x + i * fractionLength,
      y,
      "top",
      adjustment
    );
    points[`left${i}Fraction`] = adjustAttachmentPoint(
      x,
      y + i * fractionLength,
      "left",
      adjustment
    );
    points[`right${i}Fraction`] = adjustAttachmentPoint(
      x + artifactBlockSideLength,
      y + i * fractionLength,
      "right",
      adjustment
    );
    points[`bottom${i}Fraction`] = adjustAttachmentPoint(
      x + i * fractionLength,
      y + artifactBlockSideLength,
      "bottom",
      adjustment
    );
  }

  return points;
};

const calculateMiddlePoints = (x, y, adjustment) =>
  calculateEdgeFractionPoints(x, y, 2, adjustment);
const calculateEdgeThirdPoints = (x, y, adjustment) =>
  calculateEdgeFractionPoints(x, y, 3, adjustment);
const calculateEdgeFifthPoints = (x, y, adjustment) =>
  calculateEdgeFractionPoints(x, y, 5, adjustment);

const mapWorkflows = [
  {
    operationId: 101010,
    source: "Customer Order",
    target: "Sales Order",
    startX: calculateMiddlePoints(
      mapArtifactsObject["Customer Order"].x,
      mapArtifactsObject["Customer Order"].y
    ).right1Fraction.x,
    startY: calculateMiddlePoints(
      mapArtifactsObject["Customer Order"].x,
      mapArtifactsObject["Customer Order"].y
    ).right1Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Sales Order"].x,
      mapArtifactsObject["Sales Order"].y,
      connectionEndOffset
    ).top1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Sales Order"].x,
      mapArtifactsObject["Sales Order"].y,
      connectionEndOffset
    ).top1Fraction.y,
    turns: 1,
    statusBoxAlignment: "start",
    direction: "horizontal",
  },
  {
    operationId: 103040,
    source: "Sales Order",
    target: "Customer Prepayment",
    startX: calculateMiddlePoints(
      mapArtifactsObject["Sales Order"].x,
      mapArtifactsObject["Sales Order"].y
    ).bottom1Fraction.x,
    startY: calculateMiddlePoints(
      mapArtifactsObject["Sales Order"].x,
      mapArtifactsObject["Sales Order"].y
    ).bottom1Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Customer Prepayment"].x,
      mapArtifactsObject["Customer Prepayment"].y,
      connectionEndOffset
    ).right1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Customer Prepayment"].x,
      mapArtifactsObject["Customer Prepayment"].y,
      connectionEndOffset
    ).right1Fraction.y,
    turns: 1,
    statusBoxAlignment: "start",
    direction: "vertical",
  },
  {
    operationId: 101020,
    source: "Customer Order Change",
    target: "Sales Order",
    startX: calculateMiddlePoints(
      mapArtifactsObject["Customer Order Change"].x,
      mapArtifactsObject["Customer Order Change"].y
    ).right1Fraction.x,
    startY: calculateMiddlePoints(
      mapArtifactsObject["Customer Order Change"].x,
      mapArtifactsObject["Customer Order Change"].y
    ).right1Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Sales Order"].x,
      mapArtifactsObject["Sales Order"].y,
      connectionEndOffset
    ).left1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Sales Order"].x,
      mapArtifactsObject["Sales Order"].y,
      connectionEndOffset
    ).left1Fraction.y,
    turns: 0,
    statusBoxAlignment: "start",
    direction: "horizontal",
  },
  {
    operationId: 101040,
    source: "Sales Order",
    target: "Customer Order Ack",
    startX: calculateEdgeFifthPoints(
      mapArtifactsObject["Sales Order"].x,
      mapArtifactsObject["Sales Order"].y
    ).left1Fraction.x,
    startY: calculateEdgeFifthPoints(
      mapArtifactsObject["Sales Order"].x,
      mapArtifactsObject["Sales Order"].y
    ).left1Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Customer Order Ack"].x,
      mapArtifactsObject["Customer Order Ack"].y,
      connectionEndOffset
    ).right1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Customer Order Ack"].x,
      mapArtifactsObject["Customer Order Ack"].y,
      connectionEndOffset
    ).right1Fraction.y,
    turns: 2,
    statusBoxAlignment: "end",
    direction: "horizontal",
  },
  {
    operationId: 101050,
    source: "Sales Order",
    target: "Customer Order Change Ack",
    startX: calculateEdgeFifthPoints(
      mapArtifactsObject["Sales Order"].x,
      mapArtifactsObject["Sales Order"].y
    ).left4Fraction.x,
    startY: calculateEdgeFifthPoints(
      mapArtifactsObject["Sales Order"].x,
      mapArtifactsObject["Sales Order"].y
    ).left4Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Customer Order Change Ack"].x,
      mapArtifactsObject["Customer Order Change Ack"].y,
      connectionEndOffset
    ).right1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Customer Order Change Ack"].x,
      mapArtifactsObject["Customer Order Change Ack"].y,
      connectionEndOffset
    ).right1Fraction.y,
    turns: 2,
    statusBoxAlignment: "end",
    direction: "horizontal",
  },
  {
    operationId: 101030,
    source: "Sales Order",
    target: "Customer Order Status",
    startX: calculateEdgeFifthPoints(
      mapArtifactsObject["Sales Order"].x,
      mapArtifactsObject["Sales Order"].y
    ).bottom1Fraction.x,
    startY: calculateEdgeFifthPoints(
      mapArtifactsObject["Sales Order"].x,
      mapArtifactsObject["Sales Order"].y
    ).bottom1Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Customer Order Status"].x,
      mapArtifactsObject["Customer Order Status"].y,
      connectionEndOffset
    ).right1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Customer Order Status"].x,
      mapArtifactsObject["Customer Order Status"].y,
      connectionEndOffset
    ).right1Fraction.y,
    turns: 1,
    statusBoxAlignment: "end",
    direction: "horizontal",
  },
  {
    operationId: 102010,
    source: "Sales Order",
    target: "Pick Order",
    startX: calculateEdgeFifthPoints(
      mapArtifactsObject["Sales Order"].x,
      mapArtifactsObject["Sales Order"].y
    ).bottom4Fraction.x,
    startY: calculateEdgeFifthPoints(
      mapArtifactsObject["Sales Order"].x,
      mapArtifactsObject["Sales Order"].y
    ).bottom4Fraction.y,
    endX: calculateEdgeFifthPoints(
      mapArtifactsObject["Pick Order"].x,
      mapArtifactsObject["Pick Order"].y,
      connectionEndOffset
    ).top4Fraction.x,
    endY: calculateEdgeFifthPoints(
      mapArtifactsObject["Pick Order"].x,
      mapArtifactsObject["Pick Order"].y,
      connectionEndOffset
    ).top4Fraction.y,
    turns: 0,
    statusBoxAlignment: "end",
    direction: "vertical",
  },
  {
    source: "Pick Order",
    target: "Packed Order",
    startX: calculateMiddlePoints(
      mapArtifactsObject["Pick Order"].x,
      mapArtifactsObject["Pick Order"].y
    ).bottom1Fraction.x,
    startY: calculateMiddlePoints(
      mapArtifactsObject["Pick Order"].x,
      mapArtifactsObject["Pick Order"].y
    ).bottom1Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Packed Order"].x,
      mapArtifactsObject["Packed Order"].y,
      connectionEndOffset
    ).top1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Packed Order"].x,
      mapArtifactsObject["Packed Order"].y,
      connectionEndOffset
    ).top1Fraction.y,
    turns: 0,
    notTrueWorkflow: true,
    statusBoxAlignment: "start",
    direction: "vertical",
  },
  {
    operationId: 102051,
    source: "Packed Order",
    target: "Shipment",
    startX: calculateMiddlePoints(
      mapArtifactsObject["Packed Order"].x,
      mapArtifactsObject["Packed Order"].y
    ).bottom1Fraction.x,
    startY: calculateMiddlePoints(
      mapArtifactsObject["Packed Order"].x,
      mapArtifactsObject["Packed Order"].y
    ).bottom1Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Shipment"].x,
      mapArtifactsObject["Shipment"].y,
      connectionEndOffset
    ).top1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Shipment"].x,
      mapArtifactsObject["Shipment"].y,
      connectionEndOffset
    ).top1Fraction.y,
    turns: 0,
    statusBoxAlignment: "end",
    direction: "vertical",
  },
  {
    source: "Shipment",
    target: "Invoice",
    startX: calculateMiddlePoints(
      mapArtifactsObject["Shipment"].x,
      mapArtifactsObject["Shipment"].y
    ).bottom1Fraction.x,
    startY: calculateMiddlePoints(
      mapArtifactsObject["Shipment"].x,
      mapArtifactsObject["Shipment"].y
    ).bottom1Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Invoice"].x,
      mapArtifactsObject["Invoice"].y,
      connectionEndOffset
    ).top1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Invoice"].x,
      mapArtifactsObject["Invoice"].y,
      connectionEndOffset
    ).top1Fraction.y,
    turns: 0,
    notTrueWorkflow: true,
  },
  {
    source: "Invoice",
    target: "Credit Note",
    startX: calculateMiddlePoints(
      mapArtifactsObject["Invoice"].x,
      mapArtifactsObject["Invoice"].y
    ).bottom1Fraction.x,
    startY: calculateMiddlePoints(
      mapArtifactsObject["Invoice"].x,
      mapArtifactsObject["Invoice"].y
    ).bottom1Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Credit Note"].x,
      mapArtifactsObject["Credit Note"].y,
      connectionEndOffset
    ).top1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Credit Note"].x,
      mapArtifactsObject["Credit Note"].y,
      connectionEndOffset
    ).top1Fraction.y,
    turns: 0,
    notTrueWorkflow: true,
  },
  {
    operationId: 103010,
    source: "Invoice",
    target: "Customer Invoice",
    startX: calculateMiddlePoints(
      mapArtifactsObject["Invoice"].x,
      mapArtifactsObject["Invoice"].y
    ).left1Fraction.x,
    startY: calculateMiddlePoints(
      mapArtifactsObject["Invoice"].x,
      mapArtifactsObject["Invoice"].y
    ).left1Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Customer Invoice"].x,
      mapArtifactsObject["Customer Invoice"].y,
      connectionEndOffset
    ).right1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Customer Invoice"].x,
      mapArtifactsObject["Customer Invoice"].y,
      connectionEndOffset
    ).right1Fraction.y,
    turns: 0,
    statusBoxAlignment: "end",
    direction: "horizontal",
  },
  {
    operationId: 103020,
    source: "Credit Note",
    target: "Customer Credit Note",
    startX: calculateMiddlePoints(
      mapArtifactsObject["Credit Note"].x,
      mapArtifactsObject["Credit Note"].y
    ).left1Fraction.x,
    startY: calculateMiddlePoints(
      mapArtifactsObject["Credit Note"].x,
      mapArtifactsObject["Credit Note"].y
    ).left1Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Customer Credit Note"].x,
      mapArtifactsObject["Customer Credit Note"].y,
      connectionEndOffset
    ).right1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Customer Credit Note"].x,
      mapArtifactsObject["Customer Credit Note"].y,
      connectionEndOffset
    ).right1Fraction.y,
    turns: 0,
    statusBoxAlignment: "end",
    direction: "horizontal",
  },
  {
    operationId: 102040,
    source: "Customer Routing Confirmation",
    target: "Packed Order",
    startX: calculateMiddlePoints(
      mapArtifactsObject["Customer Routing Confirmation"].x,
      mapArtifactsObject["Customer Routing Confirmation"].y
    ).right1Fraction.x,
    startY: calculateMiddlePoints(
      mapArtifactsObject["Customer Routing Confirmation"].x,
      mapArtifactsObject["Customer Routing Confirmation"].y
    ).right1Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Packed Order"].x,
      mapArtifactsObject["Packed Order"].y,
      connectionEndOffset
    ).left1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Packed Order"].x,
      mapArtifactsObject["Packed Order"].y,
      connectionEndOffset
    ).left1Fraction.y,
    turns: 0,
    statusBoxAlignment: "start",
    direction: "horizontal",
  },
  {
    operationId: 102030,
    source: "Packed Order",
    target: "Customer Routing Request",
    startX: calculateEdgeFifthPoints(
      mapArtifactsObject["Packed Order"].x,
      mapArtifactsObject["Packed Order"].y
    ).left1Fraction.x,
    startY: calculateEdgeFifthPoints(
      mapArtifactsObject["Packed Order"].x,
      mapArtifactsObject["Packed Order"].y
    ).left1Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Customer Routing Request"].x,
      mapArtifactsObject["Customer Routing Request"].y,
      connectionEndOffset
    ).right1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Customer Routing Request"].x,
      mapArtifactsObject["Customer Routing Request"].y,
      connectionEndOffset
    ).right1Fraction.y,
    turns: 2,
    statusBoxAlignment: "end",
    direction: "horizontal",
  },
  {
    operationId: 102060,
    source: "Shipment",
    target: "Customer Shipment Notice",
    startX: calculateMiddlePoints(
      mapArtifactsObject["Shipment"].x,
      mapArtifactsObject["Shipment"].y
    ).left1Fraction.x,
    startY: calculateMiddlePoints(
      mapArtifactsObject["Shipment"].x,
      mapArtifactsObject["Shipment"].y
    ).left1Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Customer Shipment Notice"].x,
      mapArtifactsObject["Customer Shipment Notice"].y,
      connectionEndOffset
    ).right1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Customer Shipment Notice"].x,
      mapArtifactsObject["Customer Shipment Notice"].y,
      connectionEndOffset
    ).right1Fraction.y,
    turns: 0,
    statusBoxAlignment: "end",
    direction: "horizontal",
  },
  {
    operationId: 102020,
    source: "Inventory Availability",
    target: "Customer Inventory Availability",
    startX: calculateMiddlePoints(
      mapArtifactsObject["Inventory Availability"].x,
      mapArtifactsObject["Inventory Availability"].y
    ).left1Fraction.x,
    startY: calculateMiddlePoints(
      mapArtifactsObject["Inventory Availability"].x,
      mapArtifactsObject["Inventory Availability"].y
    ).left1Fraction.y,
    endX: calculateMiddlePoints(
      mapArtifactsObject["Customer Inventory Availability"].x,
      mapArtifactsObject["Customer Inventory Availability"].y,
      connectionEndOffset
    ).right1Fraction.x,
    endY: calculateMiddlePoints(
      mapArtifactsObject["Customer Inventory Availability"].x,
      mapArtifactsObject["Customer Inventory Availability"].y,
      connectionEndOffset
    ).right1Fraction.y,
    turns: 0,
    statusBoxAlignment: "end",
    direction: "horizontal",
  },
];

export {
  mapArtifacts,
  mapWorkflows,
  calculateMiddlePoints,
  calculateEdgeThirdPoints,
  leftColumn,
  rightColumn,
  baseYOffset,
  spacing,
  artifactBlockSideLength,
};
